// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:768px){body.mini-website .jade-hamburger[data-v-7c6227a7]{display:block}}", ""]);
// Exports
module.exports = exports;
